import { create } from "zustand";

interface FormDraftStoreState {
  drafts: Record<string, unknown>;
  setDraft: <TDraft>(key: string, draft: TDraft) => void;
  getDraft: <TDraft>(key: string) => TDraft | undefined;
  clearDraft: (key: string) => void;
  clearAllDrafts: () => void;
}

export const useFormDraftStore = create<FormDraftStoreState>()((set, get) => ({
  drafts: {},
  setDraft: (key, draft) =>
    set((state) => ({
      drafts: {
        ...state.drafts,
        [key]: draft,
      },
    })),
  getDraft: <TDraft>(key: string) => get().drafts[key] as TDraft | undefined,
  clearDraft: (key) =>
    set((state) => {
      if (!(key in state.drafts)) {
        return state;
      }

      const nextDrafts = { ...state.drafts };
      delete nextDrafts[key];
      return { drafts: nextDrafts };
    }),
  clearAllDrafts: () => set({ drafts: {} }),
}));

export function useRouteFormDraft<TDraft>(key: string): TDraft | undefined {
  return useFormDraftStore((state) => state.drafts[key] as TDraft | undefined);
}
